// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Vz5I","footer":"ModalError_footer__1Bvtm"};